module.exports = __webpack_public_path__ + "bea9a95908a12805cb9f271ef34d588a.svg";